(() => {
  function setupLottieInteractivity(playerId) {
    document.getElementById(playerId).addEventListener('ready', () => {
      LottieInteractivity.create({
        player: '#' + playerId,
        mode: 'scroll',
        actions: [
          {
            visibility: [0.25, 1.0],
            type: 'playOnce'
          }
        ]
      });
    });
  }

  setupLottieInteractivity('case_study_resource__lottie_1');
  setupLottieInteractivity('case_study_resource__lottie_2');
  setupLottieInteractivity('case_study_resource__lottie_3');

  const setCentered = (el) => {
    if (window.innerWidth < 900) return;
    let disabled = el.slides.length < 2;
    el.params.centeredSlides = disabled;
    el.params.pagination.clickable = !!disabled;
    el.params.scrollbar.hide = !!disabled;
  }
  new Swiper('[data-feature-swiper-slider]', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 1,
    centeredSlides: false,
    spaceBetween: 28,
    grabCursor: true,
    autoplay: {
      enabled: true,
      delay: 5000
    },
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      900: {
        slidesPerView: 3,
        slidesPerGroup: 3
      },
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    on: {
      beforeInit: function (el) {
        let delay = parseFloat(el.el.dataset.swiperAutoplay);
        el.params.autoplay.delay = !!delay && delay;
        el.params.autoplay.enabled = !!delay;

      },
      resize: (el) => setCentered(el),
      afterInit: (el) => setCentered(el)
    }
  });
})();
